import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Button from "../Button";
import MenuItem from "../MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MuiMenu from "@mui/material/Menu";
import classNames from "classnames";
import useStyles from "./styles";
const Menu = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    color = "default",
    id,
    items,
    variant = "text",
    size = "medium",
    className,
    title,
    onMouseDown,
    stopPropagation,
    closeOnClick = true,
    icon,
    type = "default",
    headerText,
    ButtonProps,
    MenuItemProps,
    ListItemIconProps,
    classes: classesProp,
    ...otherProps
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles(props);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    if (stopPropagation) {
      event.stopPropagation();
    }
  };
  const handleClose = event => {
    setAnchorEl(null);
    if (stopPropagation) {
      event.stopPropagation();
    }
  };
  const handleEvent = (event, action) => {
    if (action) {
      action(event);
    }
    if (closeOnClick) {
      handleClose(event);
    }
  };
  const menuButtonProps = icon ? {
    content: icon,
    type: "icon"
  } : type === "action" ? {
    content: /*#__PURE__*/React.createElement(MoreVertIcon, null),
    type: "icon",
    title: "Actions"
  } : {
    content: headerText,
    type: "default"
  };
  const anchorOrigin = type === "default" ? {
    vertical: "bottom",
    horizontal: "center"
  } : type === "none" ? undefined : {
    vertical: "bottom",
    horizontal: "right"
  };
  const transformOrigin = type === "default" ? {
    vertical: "top",
    horizontal: "center"
  } : type === "none" ? undefined : {
    vertical: "top",
    horizontal: "right"
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({
    ref: ref,
    id: id,
    color: color,
    size: size,
    variant: variant,
    "aria-owns": anchorEl ? "simple-menu" : undefined,
    "aria-haspopup": "true",
    onClick: handleClick,
    type: menuButtonProps.type,
    title: title ? title : menuButtonProps.title ? menuButtonProps.title : undefined,
    onMouseDown: onMouseDown
  }, ButtonProps, {
    className: classNames("prmbl-menu-button", ButtonProps?.className, className, classes.button, {
      "prmbl-menu-button--menu-is-open": anchorEl != null
    })
  }), menuButtonProps.content), /*#__PURE__*/React.createElement(MuiMenu, _extends({
    id: `${id}-menu`,
    className: classNames("prmbl-menu", className, classes.menu),
    classes: {
      paper: classes.paper
    },
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin
  }, otherProps, {
    MenuListProps: {
      disablePadding: true,
      ...otherProps.MenuListProps
    }
  }), items.map((item, index) => {
    const {
      action,
      className: itemClassName,
      children: itemChildren,
      onClick,
      ...otherItemProps
    } = item;
    const key = `${id}-menuitem-${index}`;
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      id: key,
      key: key,
      onClick: onClick ? event => handleEvent(event, onClick) : undefined
    }, MenuItemProps, {
      className: classNames("prmbl-menu-item", MenuItemProps?.className, itemClassName, className, classes.item),
      ListItemIconProps: ListItemIconProps
    }, otherItemProps), MenuItemProps?.children || itemChildren);
  })));
});
Menu.displayName = "Menu";
Menu.defaultProps = {
  variant: "text",
  color: "default",
  size: "medium",
  type: "default",
  closeOnClick: true
};
export default Menu;